exports.gql=function(){};
